import { Typography } from "@mui/material";

const AudioLoadingDescription: React.FC<{
  loading: boolean, loadingMessage?: string, finishMessage?: string
}> = ({loading, loadingMessage, finishMessage}) => {

  return (
    <div id='loading-description' className='accessibility-sr-only' role='status' aria-live="assertive" aria-atomic>
      <Typography className="accessibility-sr-only">
        {(loading) ? loadingMessage || "Carregando" : finishMessage || "Carregamento finalizado"}
      </Typography>
    </div>
  );
}

export default AudioLoadingDescription;
